<template>
  <div class="mm-search relative">
    <input
      :value="modelValue"
      @input="onInput"
      type="search"
      class="w-full bg-white px-3 py-3 h-10 pr-9 text-sm font-bold uppercase italic outline-none"
      :placeholder="placeholder || 'Zoeken'"
      :aria-label="ariaLabel || placeholder || 'Zoeken'"
    />
    <span class="absolute right-2 top-1/2 -translate-y-1/2 text-neutral-500" aria-hidden="true">
      <svg viewBox="0 0 24 24" class="h-5 w-5"><path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 5L20.49 19l-5-5Zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14Z"/></svg>
    </span>
  </div>
  
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, default: 'Zoek in resultaten' },
  ariaLabel: { type: String, default: '' },
  debounce: { type: Number, default: 300 },
})
const emit = defineEmits(['update:modelValue','change'])

const timer = ref(null)
function onInput(e){
  const v = e.target.value
  if (!props.debounce) {
    emit('update:modelValue', v)
    emit('change', v)
    return
  }
  clearTimeout(timer.value)
  timer.value = setTimeout(() => {
    emit('update:modelValue', v)
    emit('change', v)
  }, props.debounce)
}
</script>

<style scoped>
</style>
